import { render, staticRenderFns } from "./DailyRoutine2.vue?vue&type=template&id=3cdb6fcf"
import script from "./DailyRoutine2.vue?vue&type=script&lang=js"
export * from "./DailyRoutine2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports